// ======================================================================
// File: src/modules/ipe/layout/IPESidebar.jsx
// ======================================================================

import React, { useContext, useEffect, useState } from "react";
import { NavLink, useLocation, Link } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import RawMaterialListPage from "../../ppe/pages/material/raw-material/RawMaterialListPage";
const canAny = (permissions, keys = []) =>
  keys.some((k) => permissions?.[k]?.view === true);

const MENU = [
  
  
  // ===================== CORE =====================
  {
    label: "Enquiry",
    route: "/ipe/enquiries",
    perms: ["PPE_VIEW_BOQ","PPE_CREATE_BOQ", "PPE_EDIT_BOQ", "PPE_APPROVE_BOQ"],
    icon: "fas fa-envelope",
  },

  // ===================== ORDER =====================
{ type: "group", label: "Order" },

{
  label: "Orders",
  route: "/ipe/orders",
  perms: ["PPE_INDENT_VIEW"],   // you can temporarily bypass if needed
  icon: "fas fa-shopping-cart",
},

// ===================== PMS =====================
{ type: "group", label: "PMS" },

{
  label: "Projects",
  route: "/ipe/pms/projects",  // temporary static
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-project-diagram",
},
{
  label: "User BP Mapping",
  route: "/ipe/pms/user-bp-mapping",
  perms: ["PPE_INDENT_VIEW"], // keep same for now
  icon: "fas fa-link",
},

{
  label: "Task Templates",
  route: "/ipe/pms/task-templates",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-tasks",
},

{
  type: "group",
  label: "Material Execution"
},
{
  label: "Material Reservation",
  route: "/ipe/pms/material-reservation",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-boxes",
},
{
  label: "Packing & Dispatch",
  route: "/ipe/pms/packing-dispatch",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-shipping-fast",
},
{
  label: "Receipt Workbench",
  route: "/ipe/pms/material-receipt",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-dolly",
},

{
  label: "Reconciliation Workbench",
  route: "/ipe/pms/material-reconciliation",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-clipboard-check",
},
{
  label: "Material Traceability",
  route: "/ipe/pms/material-traceability",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-route",
},
{
  label: "Execution Workbench",
  route: "/ipe/pms/task-execution",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-hard-hat",
},
{
  label: "Site Store Dashboard",
  route: "/ipe/pms/site-store-dashboard",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-warehouse",
},
  // ===================== ENGINEERING =====================
  { type: "group", label: "Engineering" },

  
  {
    label: "Engineering Study",
    route: "/ipe/engineering/study",
    perms: ["IPE_VIEW_STUDY"],
    icon: "fas fa-drafting-compass",
  },
  {
    label: "MOM Master",
    route: "/ipe/engineering/mom",
    perms: ["IPE_VIEW_MOM"],
    icon: "fas fa-random",
  },
  {
  label: "Product Family",
  route: "/ipe/engineering/masters/product-family",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-sitemap",
},

{
  label: "Product Variant",
  route: "/ipe/engineering/masters/product-variants",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-tags",
},

  {
  label: "Equipment Master",
  route: "/ipe/engineering/equipment",
  perms: ["PPE_INDENT_VIEW"],
  icon: "fas fa-tools",
},
{
    label: "BOM Master",
    route: "/ipe/engineering/bom",
    perms: ["PPE_VIEW_BOQ","PPE_CREATE_BOQ", "PPE_EDIT_BOQ", "PPE_APPROVE_BOQ"],
    icon: "fas fa-project-diagram",
  },

  // ===================== MATERIAL (FROM PPE) =====================
  { type: "group", label: "Material" },

  {
    label: "Raw Material",
    route: "/ipe/material/masters/raw-material",
    perms: ["RAW_MATERIAL_VIEW"],
    icon: "fas fa-cube",
  },

  // ===================== PROCUREMENT (FROM PPE) =====================
  { type: "group", label: "Procurement" },

  {
    label: "Procurement Dashboard",
    route: "/ppe/procurement",
    perms: ["PPE_INDENT_VIEW"],
    icon: "fas fa-chart-bar",
  },
  {
    label: "Indent",
    route: "/ppe/procurement/indent",
    perms: ["PPE_INDENT_VIEW"],
    icon: "fas fa-indent",
  },
  {
    label: "Purchase Request",
    route: "/ppe/procurement/purchase-request",
    perms: ["PPE_INDENT_VIEW"],
    icon: "fas fa-clipboard-list",
  },
  {
    label: "RFQ",
    route: "/ppe/procurement/rfq",
    perms: ["PPE_INDENT_VIEW"],
    icon: "fas fa-envelope-open-text",
  },
  {
    label: "Purchase Order",
    route: "/ppe/procurement/purchase-order",
    perms: ["PPE_PO_VIEW"],
    icon: "fas fa-file-invoice",
  },
  {
    label: "GRN",
    route: "/ppe/procurement/grn",
    perms: ["PPE_GRN_VIEW"],
    icon: "fas fa-dolly-flatbed",
  },

  // ===================== COSTING =====================
  { type: "group", label: "Costing" },

  {
    label: "Cost Estimation",
    route: "/ipe/costing",
    perms: ["IPE_VIEW_COST"],
    icon: "fas fa-coins",
  },

  // ===================== MASTERS =====================
  { type: "group", label: "Masters" },

  {
    label: "Business Partner",
    route: "/ipe/masters/business-partner",
    perms: ["BP_VIEW"],
    icon: "fas fa-handshake",
  },

  // ===================== QUOTATION =====================
  { type: "group", label: "Quotation" },

  {
    label: "Quotation",
    route: "/ipe/quotation",
    perms: ["BP_VIEW"],
    icon: "fas fa-file-invoice-dollar",
  },

  
  // ===================== WORKFLOW =====================
  { type: "group", label: "Workflow" },

  {
    label: "Workflow Configuration",
    route: "/ipe/workflow",
    perms: ["IPE_VIEW_WORKFLOW"],
    icon: "fas fa-sitemap",
  },
];

// ===== COMPONENT SAME (NO CHANGE) =====
export default function IPESidebar({ onToggle }) {
  const { permissions } = useContext(AuthContext);
  const location = useLocation();

  const collapsedLS = localStorage.getItem("ipe_sidebar_collapsed");
  const [expanded, setExpanded] = useState(
    collapsedLS === null ? true : collapsedLS === "false"
  );

  useEffect(() => {
    localStorage.setItem(
      "ipe_sidebar_collapsed",
      expanded ? "false" : "true"
    );
    onToggle?.(expanded);
  }, [expanded, onToggle]);

  return (
    <aside
      style={{
        width: expanded ? "260px" : "64px",
        transition: "width 0.22s ease",
        background: "#1f2937",
        color: "#fff",
        minHeight: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 100,
      }}
    >
      <div style={{
        height: "56px",
        display: "flex",
        alignItems: "center",
        justifyContent: expanded ? "space-between" : "center",
        padding: expanded ? "0 12px" : "0",
        borderBottom: "1px solid #374151",
      }}>
        {expanded && <span style={{ fontWeight: 700 }}>IPE</span>}
        <button onClick={() => setExpanded((v) => !v)} style={{
          background: "none",
          border: "none",
          color: "#9ca3af",
        }}>
          <i className="fas fa-bars" />
        </button>
      </div>

      <Link to="/dashboard" style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        margin: 12,
        padding: "10px 12px",
        borderRadius: 999,
        background: "#4f46e5",
        color: "#fff",
        textDecoration: "none",
        justifyContent: expanded ? "flex-start" : "center",
      }}>
        <i className="fas fa-home" />
        {expanded && <span>Back to Dashboard</span>}
      </Link>

      <nav style={{
        maxHeight: "calc(100vh - 140px)",
        overflowY: "auto",
      }}>
        {MENU.map((item, idx) => {
          if (item.type === "group") {
            if (!expanded) return null;
            return (
              <div key={idx} style={{
                margin: "12px 14px 6px",
                fontSize: 11,
                color: "#9ca3af",
                textTransform: "uppercase",
              }}>
                {item.label}
              </div>
            );
          }

          if (!canAny(permissions, item.perms)) return null;

          const active = location.pathname.startsWith(item.route);

          return (
            <NavLink
              key={item.route}
              to={item.route}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: expanded ? "10px 14px" : "10px 0",
                justifyContent: expanded ? "flex-start" : "center",
                color: active ? "#fff" : "#cbd5f5",
                background: active ? "#374151" : "transparent",
                textDecoration: "none",
                fontSize: 14,
              }}
            >
              <i className={item.icon} />
              {expanded && <span>{item.label}</span>}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}